<template>
  <div>
    <div class="sayfahead">
      <h1>{{SayfaAdi}}</h1>
      <el-button v-if="Kaydet" type="success" size="small" class="YeniBtn" @click="MakbuzUret"
                 icon="el-icon-check">Kaydet
      </el-button>
    </div>
    <div class="icerik">
      <Yukleniyor :data="lo"></Yukleniyor>
      <el-form :rules="FormHata" :model="Form"
               @submit.prevent.native="MakbuzUret"
               ref="Form"
      >
        <el-row :gutter="24">
          <el-col :span="4">
            <el-form-item label="Abone No" prop="AboneNo">
              <el-input @keyup.enter.native="BorcGetir" :disabled="Kaydet==true" v-model="AboneNo"/>
            </el-form-item>
          </el-col>
          <el-col :span="4" v-if="!Kaydet">
            <el-form-item label="" prop="x">
              <el-button type="info" style="margin-top: 18px" @click="BorcGetir">GETİR</el-button>
            </el-form-item>
          </el-col>
          <el-col :span="4" v-if="Kaydet">
            <el-form-item label="Kasa" prop="Kasa_id">
              <el-cascader
                collapse-tags
                :props="{ multiple: false}"
                :options="Kasalar"
                v-model="Form.Kasa_id"
                filterable></el-cascader>
            </el-form-item>
          </el-col>
          <el-col :span="4" v-if="Kaydet">
            <el-form-item label="Tutar" prop="Tutar">
              <el-input v-model="Form.Tutar"/>
            </el-form-item>
          </el-col>

          <el-col :span="4" v-if="Kaydet">
            <el-form-item label="Ödeme Tarihi" prop="oTarihi">
              <el-date-picker
                v-model="Form.oTarihi"
                type="date"
                placeholder=""
                format="dd.MM.yyyy">
              </el-date-picker>
            </el-form-item>
          </el-col>
          <el-col :span="8" v-if="Kaydet">
            <el-form-item label="Açıklama" prop="Aciklama">
              <el-input v-model="Form.Aciklama"/>
            </el-form-item>
          </el-col>
          <el-col :span="24" v-if="Borc">
            <table class="table table-bordered">
              <thead>
              <tr>
                <th colspan="5" class="text-center">Borçlandırma Bilgileri</th>
              </tr>
              <tr>
                <td><sup><b>Cari</b></sup><br> {{Borc.Cari}}</td>
                <td><sup><b>Bina</b></sup><br> {{Borc.Bina}}</td>
                <td><sup><b>Kategori</b></sup><br> {{Borc.Kategori}}</td>
                <td><sup><b>Tutar</b></sup><br> {{Borc.Tutar}}</td>
                <td><sup><b>Açıklama</b></sup><br> {{Borc.Aciklama}}</td>
              </tr>
              </thead>
            </table>
          </el-col>
        </el-row>
      </el-form>
    </div>
    <MakbuzDetay v-if="MakbuzDetayModal" :mNo="mNo" @MakbuzDetayModal="MakbuzDetayModal=false"
                 :MakbuzDetayModal="MakbuzDetayModal"></MakbuzDetay>
  </div>
</template>

<script>
  import Yukleniyor from "../../components/Doc/Yukleniyor";
  import MakbuzDetay from "../../components/Pack/Vezne/MakbuzDetay";


  export default {
    components: {MakbuzDetay, Yukleniyor},
    data() {
      return {
        lo: false,
        mNo: false,
        MakbuzDetayModal: false,
        AboneNo: null,
        Borc: null,
        SayfaAdi: 'Hızlı Abonelik Borç Ödeme',
        Kaydet: false,
        Form: {
          Kasa_id: null,
          Cari_id: null,
          Bina_id: null,
          Tutar: 0,
          oTarihi: null,
          Aciklama: null,
          Tur: 3
        },
        FormHata: {
          Kasa_id: [{required: true, message: this.$t('eGenel.12'), trigger: 'blur'}],
          Tutar: [{required: true, message: this.$t('eGenel.12'), trigger: 'blur'}],
          oTarihi: [{required: true, message: this.$t('eGenel.12'), trigger: 'blur'}],
        },
        Kasalar: []
      }
    },
    methods: {
      BorcGetir() {
        this.lo = true;
        this.$store.dispatch("Get", {path: 'muhasebe/abonelik/' + this.AboneNo})
          .then(response => {
            this.lo = false;
            if (response.Durum === 'OK') {
              this.Borc = response.Borc;
              this.Form.Tutar = response.Borc.Tutar;
              this.Form.Cari_id = response.Borc.Cari_id;
              this.Form.Bina_id = response.Borc.Bina_id;
              this.Form.Aciklama = response.Borc.Aciklama;
              this.Kaydet = true;
              $("#Tutar").focus();
              this.KasaGetir(response.Borc.Bina_id);
            } else {
              this.$message.error(response.Mesaj);
            }
          });


      },
      MakbuzUret() {
        if (this.Borc) {
          this.$refs['Form'].validate((valid) => {
            if (valid) {
              this.lo = true;
              this.$store.dispatch("Post", {...this.Form, path: 'muhasebe/odeme'})
                .then(response => {
                  if (response.Durum == "OK") {
                    this.MakbuzDetayModal = true;
                    this.mNo = response.mNo;
                    this.lo = false;
                    this.Kaydet = false;
                    this.AboneNo = null;
                    this.Form = {
                      Kasa_id: null,
                      Cari_id: null,
                      Bina_id: null,
                      Tutar: 0,
                      oTarihi: this.Form.oTarihi,
                      Aciklama: null,
                      Tur: 3
                    }
                    this.Borc = null
                  } else {
                    this.lo = false;
                    this.$message.error(response.Mesaj);
                    this.hata = response.Hata;
                  }
                })
            }
          })
        }
      },
      KasaGetir(Bina_id) {
        this.$store.dispatch("Get", {path: 'muhasebe/kasa/' + Bina_id})
          .then(response => {
            if (response.Durum === 'OK') {
              this.Kasalar = response.Liste
            } else {
              this.$message.error(response.Mesaj);
              this.hata = response.Hata;
            }
          });
      }
    }
    ,
    created() {
      this.Form.oTarihi = new Date();

    }
  }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/pages/Vezne/Abonelik.vue